function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.75rem; /* mt-3 */\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
// 컨테이너 스타일
export var ContentContainer = styled.div(_templateObject());
// 폴 컴포넌트 스타일
export var PollContainer = styled.div(_templateObject1());
